import {InjectionToken} from '@angular/core';

export const TISA_UMPIRE_URL = new InjectionToken<string>(
  'Provides base url of Umpire API.',
);

export const TISA_UMPIRE_TOKEN = new InjectionToken<string>(
  'Provides token for Umpire API authorization.',
);
